import { render } from "./BookingsIcon.vue?vue&type=template&id=4f9de300"
import script from "./BookingsIcon.vue?vue&type=script&lang=js"
export * from "./BookingsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__